// src/pages/Timeline.js

import React from 'react';

const Timeline = () => {
  return (
    <div className="main">
      <div className="column1"></div>
      <div className="column2">
        <div style={{ textAlign: 'center', margin: '2em 0' }}>
          <h1>Timeline</h1>
        </div>
        <p>
          COMING SOON
        </p>
      </div>
      <div className="column3"></div>
    </div>
  );
};

export default Timeline